import {
  Typography,
  Card,
  Box,
  Divider,
  Button,
  useMediaQuery,
  Theme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import { StatusLabel } from "../../../components/Label/status";
import AnimatedBlock from "../../../components/Common/AnimatedBlock";
import InfoRow from "../../../components/Common/InfoRow";
import { formatCrypto, formatDateTime, formatEuro } from "../../../utils/paymentFormat";

// The Coinhouse account the converted euros are credited to.
const coinhouseAccountUrl =
  process.env.NODE_ENV === "production"
    ? "https://counter.coinhouse.com"
    : "https://counter.comptoirdubitcoin.com";

// The conversions of the transaction's crypto into euros, one card each.
function InfoConversionTab({ conversions }: { conversions: any[] }) {
  const { t }: { t: any } = useTranslation();
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down("sm"));

  if (conversions.length === 0) return null;

  return (
    <Box>
      {!isMobile && (
        <Box pb={2}>
          <Typography variant="h6">{t("Conversion")}</Typography>
          <Typography variant="body2" color="text.secondary">
            {t("The crypto received, converted into euros on the Coinhouse account.")}
          </Typography>
        </Box>
      )}
      {conversions.map((conversion) => (
        <AnimatedBlock key={conversion.id}>
          <Card sx={{ mb: 2 }}>
            <Box px={2} pt={2.5} pb={1.5}>
              <Typography variant="h5" fontWeight="bold">
                {t("Conversion made on")} {formatDateTime(conversion.dateLastUpdated)}
              </Typography>
            </Box>
            <Divider />
            <Box px={2} py={1}>
              <InfoRow label={t("Converted")}>
                {formatCrypto(conversion.base)} {String(conversion.baseCurrency || "").toUpperCase()}
              </InfoRow>
              <InfoRow label={t("Received")}>{formatEuro(conversion.quote)}</InfoRow>
              <InfoRow label={t("Status")}>
                <StatusLabel fontSize="small" statusField="status" record={conversion} />
              </InfoRow>
              <InfoRow label={t("More information")}>
                <Button
                  variant="text"
                  color="primary"
                  size="small"
                  href={coinhouseAccountUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  endIcon={<OpenInNewRoundedIcon fontSize="small" />}
                >
                  {t("Go to your Coinhouse account")}
                </Button>
              </InfoRow>
            </Box>
          </Card>
        </AnimatedBlock>
      ))}
    </Box>
  );
}

export default InfoConversionTab;
